import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const formularios = {
	state: {
		
	},
	getters: {

	},
	actions: {
		sendContacto : ({commit}, data) => {
		
			return new Promise((resolve, reject) => {
				axios.post('https://dmb-ajusa.dev.doubledot.es/api/contacto',data).then( result => {
					(result.data[0] != 0  | result.data.code == 200 ) ? resolve(true) : reject(false);
				}).catch(error => {
					reject(false);
				});  
			});	
		},
		sendNewsletter : ({commit}, data)  => {
			return new Promise((resolve, reject) => {
				axios.post('https://dmb-ajusa.dev.doubledot.es/api/newsletter',data).then( result => {
					(result.data[0] != 0  | result.data.code == 200 ) ? resolve(true) : reject(false);
				}).catch(error => {
					reject(false);
				});  
			});	
		}
	}
}

export default formularios;



// WEBPACK FOOTER //
// ./src/store/formularios.js